import { render, staticRenderFns } from "./CopyItem.vue?vue&type=template&id=db5919dc&scoped=true"
import script from "./CopyItem.vue?vue&type=script&lang=js"
export * from "./CopyItem.vue?vue&type=script&lang=js"
import style0 from "./CopyItem.vue?vue&type=style&index=0&id=db5919dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5919dc",
  null
  
)

export default component.exports